import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { PodcastLandingPage } from "./components/PodcastLandingPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  useEffect(() => {
    // Load Shapo testimonials widget script
    const script = document.createElement('script');
    script.id = 'shapo-embed-js';
    script.type = 'text/javascript';
    script.src = 'https://cdn.shapo.io/js/embed.js';
    script.defer = true;
    document.head.appendChild(script);

    // Cleanup function to remove script when component unmounts
    return () => {
      const existingScript = document.getElementById('shapo-embed-js');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PodcastLandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;